import React from "react";
import { Check } from "lucide-react";

function stepStatus(index, currentStep, complete) {
  if (complete) return "complete";
  if (index === currentStep) return "active";
  return "inactive";
}

export function PortalOnboardingStepper({
  steps,
  currentStep,
  onStepChange,
  ariaLabel
}) {
  return (
    <ol className="portal-stepper portal-stepper--vertical" aria-label={ariaLabel}>
      {steps.map((step, index) => {
        const status = stepStatus(index, currentStep, step.complete);
        const isLast = index === steps.length - 1;
        const separatorComplete = step.complete;

        return (
          <li
            key={step.id}
            className="portal-stepper__step portal-stepper__step--vertical"
            data-status={status}
          >
            <button
              type="button"
              className="portal-stepper__step-button portal-stepper__step-button--vertical"
              data-clickable="true"
              aria-current={status === "active" ? "step" : undefined}
              onClick={() => onStepChange(index)}
            >
              <span className="portal-stepper__indicator" data-status={status}>
                {status === "complete" ? <Check size={14} strokeWidth={2.5} /> : step.icon}
              </span>
              <span className="portal-stepper__content portal-stepper__content--vertical">
                <span className="portal-stepper__title">{step.title}</span>
                <span className="portal-stepper__description">{step.description}</span>
              </span>
            </button>
            {!isLast ? (
              <span className="portal-stepper__separator portal-stepper__separator--vertical" aria-hidden="true">
                <span
                  className="portal-stepper__separator-track portal-stepper__separator-track--vertical"
                  data-complete={separatorComplete ? "true" : "false"}
                >
                  <span
                    className="portal-stepper__separator-fill portal-stepper__separator-fill--vertical"
                    style={{ "--stepper-separator-progress": separatorComplete ? 1 : 0 }}
                  />
                </span>
              </span>
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
